// extracted by mini-css-extract-plugin
export default {"generateText":"CustodReports_generateText__3EyHu","generateButtonContainer":"CustodReports_generateButtonContainer__KCyTH"};